import React from 'react'
import { tirupatiData } from './tourPackageData'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'
import Footer from '../../common/Footer'

const Tirupati = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Tirupati Balaji Sheegra Darshan" />
            <CommonBreadcrumb items={["Tirupati Balaji Sheegra Darshan"]} />
            <DynamicTourSection {...tirupatiData} />
            <Footer />
        </>
    )
}

export default Tirupati